import { type RouteParams } from './RouteParams';

const UNIMPLEMENTED_ROUTE = '';

export type FeatureRouteMap = {
  [Route in keyof RouteParams]: (params?: RouteParams[Route]) => {
    native: {
      routeName: Route | '';
      params?: RouteParams[Route];
    };
    web: {
      pathname: string;
    };
  };
};

export const featureRouteMap: FeatureRouteMap = {
  RouteAbout: () => ({
    native: {
      routeName: 'RouteAbout',
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteTabAccount: () => ({
    native: {
      routeName: 'RouteTabAccount',
    },
    web: {
      pathname: '/me',
    },
  }),
  RouteAddFamilyMember: () => ({
    native: {
      routeName: 'RouteAddFamilyMember',
    },
    web: {
      pathname: '/me/family_member',
    },
  }),
  RouteFamilyMemberAdded: (params) => ({
    native: {
      routeName: 'RouteFamilyMemberAdded',
      params,
    },
    web: {
      pathname: '/me/family_member/added',
      state: params,
    },
  }),
  RouteFamilyMemberBenefits: (params) => ({
    native: {
      routeName: 'RouteFamilyMemberBenefits',
      params,
    },
    web: {
      pathname: `/me/${params?.userID}/add-benefits`,
      state: params,
    },
  }),
  RouteFamilyMemberCompleteProfile: (params) => ({
    native: {
      routeName: 'RouteFamilyMemberCompleteProfile',
      params,
    },
    web: {
      pathname: `/me/${params?.userID}/complete-profile`,
    },
  }),
  RouteFamilyMemberMedicalInfo: (params) => ({
    native: {
      routeName: 'RouteFamilyMemberMedicalInfo',
      params,
    },
    web: {
      pathname: `/me/${params?.userID}/medical-info`,
      state: params,
    },
  }),
  RouteFamilyMemberRequest: (params) => ({
    native: {
      routeName: 'RouteFamilyMemberRequest',
      params,
    },
    web: {
      pathname: '/me/family_member/request',
      state: params,
    },
  }),
  RouteAddresses: () => ({
    native: {
      routeName: 'RouteAddresses',
    },
    web: {
      pathname: '/me/addresses',
    },
  }),
  RouteAppTabNavigator: (params) => ({
    native: {
      routeName: 'RouteAppTabNavigator',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteAssistantMedSelection: (params) => ({
    native: {
      routeName: 'RouteAssistantMedSelection',
      params,
    },
    web: {
      pathname: '/help/medications',
      state: params,
    },
  }),
  RouteAssistantMessage: (params) => ({
    native: {
      routeName: 'RouteAssistantMessage',
      params,
    },
    web: {
      pathname: '/help/message',
      state: params,
    },
  }),
  RouteAssistantSupportCase: (params) => ({
    native: {
      routeName: 'RouteAssistantSupportCase',
      params,
    },
    web: {
      pathname: `/help/support/${params?.supportCaseID}`,
    },
  }),
  RouteAssistantSupportCaseReply: (params) => ({
    native: {
      routeName: 'RouteAssistantSupportCaseReply',
      params,
    },
    web: {
      pathname: `/help/support/${params?.supportCaseID}/reply`,
    },
  }),
  RouteAuthStack: () => ({
    native: {
      routeName: 'RouteAuthStack',
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteAutoRefillManagement: (params) => ({
    native: {
      routeName: 'RouteAutoRefillManagement',
      params,
    },
    web: {
      pathname: '/me/auto-refills',
    },
  }),
  RouteBiometricReauth: (params) => ({
    native: {
      routeName: 'RouteBiometricReauth',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteCancelOrdersForm: (params) => ({
    native: {
      routeName: 'RouteCancelOrdersForm',
      params,
    },
    web: {
      pathname: `/orders/cancel`,
      search: params?.search,
    },
  }),
  RouteCart: (params) => ({
    native: {
      routeName: 'RouteCart',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteChangeQuantity: (params) => ({
    native: {
      routeName: 'RouteChangeQuantity',
      params,
    },
    web: {
      pathname: `/prescriptions/${params?.prescriptionID}/change-quantity`,
    },
  }),
  RouteCheckout: (params) => ({
    native: {
      routeName: 'RouteCheckout',
      params,
    },
    web: {
      pathname: '/checkout',
      state: { orderIndex: params?.orderIndex },
    },
  }),
  RouteCheckoutPhotoIdUpload: (params) => ({
    native: {
      routeName: 'RouteCheckoutPhotoIdUpload',
    },
    web: {
      pathname: '/checkout/photo-id-upload',
      state: params,
    },
  }),
  RouteCommsVerificationStatusAuthed: (params) => ({
    native: {
      routeName: 'RouteCommsVerificationStatusAuthed',
      params,
    },
    web: {
      pathname: `/communications/verify/${params?.commsChannel}/${params?.token}`,
    },
  }),
  RouteCommsVerificationStatusUnauthed: (params) => ({
    native: {
      routeName: 'RouteCommsVerificationStatusUnauthed',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteCommunicationPreferences: (params) => ({
    native: {
      routeName: 'RouteCommunicationPreferences',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteContactInfo: () => ({
    native: {
      routeName: 'RouteContactInfo',
    },
    web: {
      pathname: '/me/contact-info',
    },
  }),
  RouteTabOrders: () => ({
    native: {
      routeName: 'RouteTabOrders',
    },
    web: {
      pathname: '/orders',
    },
  }),
  RouteOrderDetails: (params) => ({
    native: {
      routeName: 'RouteOrderDetails',
      params,
    },
    web: {
      pathname: `/orders/${params?.shipmentID}`,
      state: params?.state,
    },
  }),
  RouteEditOrder: (params) => ({
    native: {
      routeName: 'RouteEditOrder',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteEditPhoneNumber: () => ({
    native: {
      routeName: 'RouteEditPhoneNumber',
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteEditTipPage: (params) => ({
    native: {
      routeName: 'RouteEditTipPage',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteEssentials: (params) => ({
    native: {
      routeName: 'RouteEssentials',
    },
    web: {
      pathname: '/store',
      search: params?.search,
    },
  }),
  RouteEssentialsCategoryDetails: (params) => ({
    native: {
      routeName: 'RouteEssentialsCategoryDetails',
      params,
    },
    web: {
      pathname: `/store/category/${params?.addOnOtcCategory?.name}`,
      search: params?.search,
    },
  }),
  RouteEssentialsDetails: (params) => ({
    native: {
      routeName: 'RouteEssentialsDetails',
      params,
    },
    web: {
      pathname: `/store/${params?.productID}`,
      search: params?.search,
      state: { analyticsProps: params?.analyticsProps },
    },
  }),
  RouteEssentialsFullScreen: (params) => ({
    native: {
      routeName: 'RouteEssentialsFullScreen',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteEssentialsSuggestFeedback: (params) => ({
    native: {
      routeName: 'RouteEssentialsSuggestFeedback',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteExistingPatientPhiAuthorization: () => ({
    native: {
      routeName: 'RouteExistingPatientPhiAuthorization',
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteFaq: (params) => ({
    native: {
      routeName: 'RouteFaq',
      params,
    },
    web: {
      pathname: `/me/faq/${params?.faqKey}`,
      state: params,
    },
  }),
  RouteFork: () => ({
    native: {
      routeName: 'RouteFork',
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteHealthProfile: (params) => ({
    native: {
      routeName: 'RouteHealthProfile',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteTabHomescreen: (params) => ({
    native: {
      routeName: 'RouteTabHomescreen',
      params,
    },
    web: {
      pathname: '/home',
    },
  }),
  RouteIdentityVerification: (params) => ({
    native: {
      routeName: 'RouteIdentityVerification',
      params,
    },
    web: {
      pathname: '/communications/verify_identity/:commsChannel',
    },
  }),
  // these are duplicates of the RouteCommsVerificationStatusUnauthed route, but we need them for web
  RouteIdentityVerificationFail: (params) => ({
    native: {
      routeName: UNIMPLEMENTED_ROUTE,
      params,
    },
    web: {
      pathname: `/communications/verify_identity/${params?.commsChannel}/fail`,
      search: params?.search,
    },
  }),
  RouteIdentityVerificationSuccess: (params) => ({
    native: {
      routeName: UNIMPLEMENTED_ROUTE,
      params,
    },
    web: {
      pathname: `/communications/verify_identity/${params?.commsChannel}/success`,
      search: params?.search,
    },
  }),
  RouteInstructionalVideos: (params) => ({
    native: {
      routeName: 'RouteInstructionalVideos',
      params,
    },
    web: {
      pathname: '/me/fertility-videos',
      state: params,
    },
  }),
  RouteInsuranceAdd: (params) => ({
    native: {
      routeName: 'RouteInsuranceAdd',
      params,
    },
    web: {
      pathname: `/me/${params?.userID}/add-benefit`,
      state: params,
    },
  }),
  RouteInsuranceCard: (params) => ({
    native: {
      routeName: 'RouteInsuranceCard',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteInsuranceForm: (params) => ({
    native: {
      routeName: 'RouteInsuranceForm',
      params,
    },
    web: {
      pathname: `/me/${params?.userID}/benefits`,
      state: params,
    },
  }),
  RouteInsurancePhotoForm: (params) => ({
    native: {
      routeName: 'RouteInsurancePhotoForm',
      params,
    },
    web: {
      pathname: `/me/${params?.userID}/benefits/photos`,
      state: params,
    },
  }),
  RouteInsuranceSection: (params) => ({
    native: {
      routeName: 'RouteInsuranceSection',
    },
    web: {
      pathname: `/me/${params?.userID}`,
    },
  }),
  RouteLearnMore: (params) => ({
    native: {
      routeName: 'RouteLearnMore',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteLogin: () => ({
    native: {
      routeName: 'RouteLogin',
    },
    web: {
      pathname: '/',
    },
  }),
  RouteLoginInfoForm: () => ({
    native: {
      routeName: 'RouteLoginInfoForm',
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteMainStackPaymentMethodPicker: (params) => ({
    native: {
      routeName: 'RouteMainStackPaymentMethodPicker',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteMedDetails: (params) => ({
    native: {
      routeName: 'RouteMedDetails',
      params,
    },
    web: {
      pathname: `/prescriptions/${params?.primaryPrescriptionId}`,
      state: { origin: params?.origin },
    },
  }),
  RouteMessages: (params) => ({
    native: {
      routeName: 'RouteMessages',
      params,
    },
    web: {
      pathname: '/help',
    },
  }),
  RouteTabMessages: (params) => ({
    native: {
      routeName: 'RouteTabMessages',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteNotificationCenter: (params) => ({
    native: {
      routeName: 'RouteNotificationCenter',
      params,
    },
    web: {
      pathname: '/notifications',
    },
  }),
  RouteMessagesDeliverySelection: (params) => ({
    native: {
      routeName: 'RouteMessagesDeliverySelection',
      params,
    },
    web: {
      pathname: '/help/deliveries',
      state: params,
    },
  }),
  RouteTabMyMeds: (params) => ({
    native: {
      routeName: 'RouteTabMyMeds',
      params,
    },
    web: {
      pathname: '/prescriptions',
      state: { origin: params?.origin },
    },
  }),
  RouteNeedlePrompt: () => ({
    native: {
      routeName: 'RouteNeedlePrompt',
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteOnboardingContactVerification: (params) => ({
    native: {
      routeName: 'RouteOnboardingContactVerification',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteOnboardingGeoUncovered: () => ({
    native: {
      routeName: 'RouteOnboardingGeoUncovered',
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteOnboardingGeoVerify: (params) => ({
    native: {
      routeName: 'RouteOnboardingGeoVerify',
    },
    web: {
      pathname: '/signup',
      search: params?.search,
    },
  }),
  RouteOnboardingHealthProfile: (params) => ({
    native: {
      routeName: 'RouteOnboardingHealthProfile',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteOnboardingInsurance: (params) => ({
    native: {
      routeName: 'RouteOnboardingInsurance',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteOnboardingLandingPage: () => ({
    native: {
      routeName: 'RouteOnboardingLandingPage',
    },
    web: {
      pathname: '/patient-onboarding',
    },
  }),
  RouteOnboardingPersonal: () => ({
    native: {
      routeName: 'RouteOnboardingPersonal',
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteOnboardingPrescriptions: (params) => ({
    native: {
      routeName: 'RouteOnboardingPrescriptions',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteOnboardingResume: (params) => ({
    native: {
      routeName: 'RouteOnboardingResume',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteOnboardingVerify: (params) => ({
    native: {
      routeName: 'RouteOnboardingVerify',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteOrderEarlyForm: (params) => ({
    native: {
      routeName: 'RouteOrderEarlyForm',
      params,
    },
    web: {
      pathname: `/prescriptions/${params?.prescriptionId}/order-early`,
    },
  }),
  RouteOrderEarlySubmit: (params) => ({
    native: {
      routeName: 'RouteOrderEarlySubmit',
      params,
    },
    web: {
      pathname: `/prescriptions/${params?.prescriptionId}/order-early/submit`,
    },
  }),
  RouteOrderSuccess: (params) => ({
    native: {
      routeName: 'RouteOrderSuccess',
      params,
    },
    web: {
      pathname: `/store/order-success/${params?.shipmentIDs[0]}`,
      search: params?.search,
      state: { bundledPrescriptionIDs: params?.bundledPrescriptionIDs },
    },
  }),
  RoutePayments: () => ({
    native: {
      routeName: 'RoutePayments',
    },
    web: {
      pathname: '/me/payments',
    },
  }),
  RoutePhotoId: () => ({
    native: {
      routeName: 'RoutePhotoId',
    },
    web: {
      pathname: '/checkout/photo-id-upload',
    },
  }),
  RoutePrescriptionStatusPage: (params) => ({
    native: {
      routeName: 'RoutePrescriptionStatusPage',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RoutePriceConfirmation: (params) => ({
    native: {
      routeName: 'RoutePriceConfirmation',
      params,
    },
    web: {
      pathname: '/price_confirmation',
      state: params,
    },
  }),
  RouteProgynyWizardCalculating: () => ({
    native: {
      routeName: 'RouteProgynyWizardCalculating',
    },
    web: {
      pathname: '/checkout/progyny-wizard/calculating-quantities',
    },
  }),
  RouteProgynyWizardDosageCheck: () => ({
    native: {
      routeName: 'RouteProgynyWizardDosageCheck',
    },
    web: {
      pathname: '/checkout/progyny-wizard/dosage-check',
    },
  }),
  RouteProgynyWizardIntro: () => ({
    native: {
      routeName: 'RouteProgynyWizardIntro',
    },
    web: {
      pathname: '/checkout/progyny-wizard/intro-1',
    },
  }),
  RouteProgynyWizardIntro2: () => ({
    native: {
      routeName: 'RouteProgynyWizardIntro2',
    },
    web: {
      pathname: '/checkout/progyny-wizard/intro-2',
    },
  }),
  RouteProgynyWizardIntro3: () => ({
    native: {
      routeName: 'RouteProgynyWizardIntro3',
    },
    web: {
      pathname: '/checkout/progyny-wizard/intro-3',
    },
  }),
  RouteProgynyWizardLeftoverMeds: () => ({
    native: {
      routeName: 'RouteProgynyWizardLeftoverMeds',
    },
    web: {
      pathname: '/checkout/progyny-wizard/leftover-meds',
    },
  }),
  RouteProgynyWizardQuantityReview: () => ({
    native: {
      routeName: 'RouteProgynyWizardQuantityReview',
    },
    web: {
      pathname: '/checkout/progyny-wizard/quantities-review',
    },
  }),
  RouteProgynyWizardStartDate: () => ({
    native: {
      routeName: 'RouteProgynyWizardStartDate',
    },
    web: {
      pathname: '/checkout/progyny-wizard/start-date',
    },
  }),
  RouteProgynyWizardTriggerDate: () => ({
    native: {
      routeName: 'RouteProgynyWizardTriggerDate',
    },
    web: {
      pathname: '/checkout/progyny-wizard/trigger-date',
    },
  }),
  RouteRateShipment: (params) => ({
    native: {
      routeName: 'RouteRateShipment',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteSelectPaymentMethod: () => ({
    native: {
      routeName: 'RouteSelectPaymentMethod',
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteSelectPaymentMethodAddCard: (params) => ({
    native: {
      routeName: 'RouteSelectPaymentMethodAddCard',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteSnoozeShipment: (params) => ({
    native: {
      routeName: 'RouteSnoozeShipment',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteSupport: (params) => ({
    native: {
      routeName: 'RouteSupport',
      params,
    },
    web: {
      pathname: '/me/contact-support',
    },
  }),
  RouteSendPrescriptionOptions: (params) => ({
    native: {
      routeName: 'RouteSendPrescriptionOptions',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RoutePharmacyInfo: (params) => ({
    native: {
      routeName: 'RoutePharmacyInfo',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteTransferOptions: (params) => ({
    native: {
      routeName: UNIMPLEMENTED_ROUTE,
      params,
    },
    web: {
      pathname: '/me/send-prescription-options',
    },
  }),
  RouteTransferPrescription: (params) => ({
    native: {
      routeName: 'RouteTransferPrescription',
      params,
    },
    web: {
      pathname: '/transfer',
      state: params,
    },
  }),
  RouteTransferSuccess: () => ({
    native: {
      routeName: 'RouteTransferSuccess',
    },
    web: {
      pathname: '/transfer/success',
    },
  }),
  RouteUpcomingDeliveryPriceDetails: (params) => ({
    native: {
      routeName: 'RouteUpcomingDeliveryPriceDetails',
      params,
    },
    web: {
      pathname: `/help/deliveries/price-details/${params?.shipmentID}`,
      state: params,
    },
  }),
  RouteUserProfile: (params) => ({
    native: {
      routeName: 'RouteUserProfile',
      params,
    },
    web: {
      pathname: `/me/${params?.userID}`,
    },
  }),
  RouteVacationRequestFailure: (params) => ({
    native: {
      routeName: 'RouteVacationRequestFailure',
      params,
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
  RouteWelcome: () => ({
    native: {
      routeName: 'RouteWelcome',
    },
    web: {
      pathname: UNIMPLEMENTED_ROUTE,
    },
  }),
};
